import { CommentsQuestion } from '../comments/comments-question';
import { Effectiveness } from './effectiveness';
import { OthersScoreModel } from './others-score-model';
import { ScoreModel } from './score-model';

export interface ScoreModels {
  self: ScoreModel[][];
  benchmark: ScoreModel[][];
  others: ScoreModel[][];
  effectiveness: Effectiveness[];
  campaignEffectiveness: Effectiveness[];
  comments: CommentsQuestion[];
  othersComments: CommentsQuestion[];
  groupResults: OthersScoreModel[];
}
